import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { prepareData } from 'utils/googleData'

export const PricingHero = (props) => {
    const {
        enable,
        title,
        subtitle,
        description,
        cta,
        direction,
        style,
        gatsbyImage,
        features,
        gatsbyImage2,
        imageMaxWidth,
        imageMaxHeight,
    } = prepareData({ props })
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }

    return (
        <section dir={direction}>
            <div
                className={`md:mt-18 mb-4 grid items-center gap-y-3 md:mt-12 md:grid-cols-2 md:gap-x-4 md:gap-y-0 md:px-4`}
            >
                {gatsbyImage && (
                    <div className="md:order-2">
                        <GatsbyImage
                            alt={title}
                            image={gatsbyImage}
                            className="max-w-screen-sm"
                            loading="eager"
                            placeholder="none"
                        />
                    </div>
                )}
                <div className="md:order-1">
                    <h1 className="mt-0 mb-4 text-3xl sm:text-4xl md:text-5xl">{title}</h1>
                    <p className="text-base font-medium leading-tight opacity-60">
                        {subtitle} <br className="hidden lg:block" />
                        {description}
                    </p>
                </div>
            </div>
        </section>
    )
}
